/* Gooseberry — Build Your Bundle (Option A)
 * Adds each piece as its own cart line with a hidden `_gb_bundle` property.
 * The discount itself is applied by the "Gooseberry Bundle Discount" Shopify Function.
 *
 * TIERS must match the discount function. */
(function () {
  'use strict';

  var MAX = 5;
  var TIERS = [ // highest first
    { min: 5, pct: 20 },
    { min: 4, pct: 15 },
    { min: 3, pct: 10 }
  ];

  /* ---------- pure helpers (also exported for tests) ---------- */
  function pctFor(n) {
    for (var i = 0; i < TIERS.length; i++) if (n >= TIERS[i].min) return TIERS[i].pct;
    return 0;
  }

  function summarise(sel) {
    var n = sel.length;
    var pct = pctFor(n);
    var sub = 0, save = 0;
    sel.forEach(function (s) {
      sub += s.price;
      save += Math.round(s.price * pct / 100); // Shopify rounds per line; close enough per item
    });
    var msg, ok = pct > 0, upsell = '';
    if (n === 0) msg = 'Choose 3 or more pieces to unlock bundle pricing';
    else if (n < 3) msg = 'Add ' + (3 - n) + ' more to save 10%';
    else if (n < MAX) { msg = pct + '% off applied'; upsell = 'Add one more piece for ' + pctFor(n + 1) + '% off'; }
    else msg = '20% off applied — your bundle is complete';
    return { n: n, pct: pct, sub: sub, save: save, total: sub - save, msg: msg, ok: ok, upsell: upsell, full: n >= MAX };
  }

  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = (cents / 100);
    function delimit(num, decimals, thousands, decimal) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delimit(value, 0, ',', '.');
        case 'amount_with_comma_separator': return delimit(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delimit(value, 2, "'", '.');
        default: return delimit(value, 2, ',', '.');
      }
    });
  }

  function groupItems(sel, bundleId, label) {
    var byVariant = {};
    var order = [];
    sel.forEach(function (s) {
      if (!byVariant[s.variantId]) { byVariant[s.variantId] = 0; order.push(s.variantId); }
      byVariant[s.variantId] += 1;
    });
    return order.map(function (id) {
      return { id: Number(id), quantity: byVariant[id], properties: { _gb_bundle: bundleId, Bundle: label } };
    });
  }

  function newBundleId() {
    return 'GB-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { pctFor: pctFor, summarise: summarise, formatMoney: formatMoney, groupItems: groupItems, newBundleId: newBundleId, MAX: MAX };
    return;
  }

  /* ---------- DOM ---------- */

  /* Turns the product description HTML into a short intro + collapsible spec sections.
     Only text is read from the HTML (textContent), so no merchant markup or styles leak in. */
  function renderDescription(html, mount, cls) {
    mount.innerHTML = '';
    if (!html) return;
    var doc = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
    var wrap = doc.body.firstElementChild;
    var clean = function (t) { return String(t || '').replace(/\s+/g, ' ').trim(); };
    var isList = function (el) { return el && /^(UL|OL)$/.test(el.tagName); };
    function isHeading(el) {
      if (/^H[1-6]$/.test(el.tagName)) return true;
      if (el.tagName !== 'P') return false;
      var t = clean(el.textContent);
      if (!t || t.length > 40) return false;
      if (el.querySelector('u, strong, b, [style*="underline"]')) return true;
      var next = el.nextElementSibling;
      while (next && !clean(next.textContent) && !isList(next)) next = next.nextElementSibling;
      return isList(next);
    }
    var intro = [], sections = [], cur = null;
    Array.prototype.forEach.call(wrap.children, function (el) {
      if (isHeading(el)) { cur = { title: clean(el.textContent).replace(/[:\s]+$/, ''), items: [], text: [] }; sections.push(cur); return; }
      if (isList(el)) {
        var items = Array.prototype.map.call(el.querySelectorAll('li'), function (li) { return clean(li.textContent); }).filter(Boolean);
        if (cur) cur.items = cur.items.concat(items); else intro.push(items.join(' · '));
        return;
      }
      var t = clean(el.textContent);
      if (!t) return;
      if (cur) cur.text.push(t); else intro.push(t);
    });
    if (!sections.length && intro.length === 0) { intro.push(clean(wrap.textContent)); }
    intro.filter(Boolean).forEach(function (t) {
      var p = document.createElement('p'); p.className = cls + '__lede'; p.textContent = t; mount.appendChild(p);
    });
    sections.forEach(function (s, i) {
      if (!s.items.length && !s.text.length) return;
      var d = document.createElement('details'); d.className = cls + '__sec';
      var sum = document.createElement('summary'); sum.textContent = s.title;
      var ch = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      ch.setAttribute('width', '12'); ch.setAttribute('height', '12'); ch.setAttribute('viewBox', '0 0 24 24'); ch.setAttribute('aria-hidden', 'true');
      ch.innerHTML = '<path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.6"/>';
      sum.appendChild(ch); d.appendChild(sum);
      if (s.items.length) {
        var ul = document.createElement('ul');
        s.items.forEach(function (t) { var li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
        d.appendChild(ul);
      }
      s.text.forEach(function (t) { var p = document.createElement('p'); p.textContent = t; d.appendChild(p); });
      mount.appendChild(d);
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function storage() {
    try { var k = '__gbb'; window.sessionStorage.setItem(k, k); window.sessionStorage.removeItem(k); return window.sessionStorage; }
    catch (e) { return null; }
  }

  /* ---------- open the theme's cart drawer with fresh contents ----------
     The theme's "apps:product-added-to-cart" event only refreshes the cart, it doesn't open the drawer
     (Rebuy used to do that until its embed was switched off). So: tell the theme, reload the drawer's
     contents, then click the bag icon — the same way the collection quick add and the welcome-back
     popup open it. */
  function openCartDrawer(cfg, items) {
    if (cfg.drawerEvent) {
      try { document.dispatchEvent(new CustomEvent(cfg.drawerEvent, { bubbles: true, detail: { items: items } })); } catch (e) {}
    }
    try { if (typeof window.updateCartCount === 'function') window.updateCartCount(); } catch (e) {}
    var isOpen = function () {
      return !!document.querySelector('.quick-cart__wrapper.active') || document.body.getAttribute('data-fluorescent-overlay-open') === 'true';
    };
    setTimeout(function () {
      try { if (typeof window.refreshCart === 'function') window.refreshCart(); } catch (e) {}
      setTimeout(function () {
        if (isOpen()) return;
        var icon = document.querySelector('a[data-js-cart-icon]') || document.querySelector('[data-js-cart-icon]');
        if (icon) icon.click(); else window.location.href = cfg.cartUrl || '/cart';
      }, 500);
    }, 200);
  }

  function init(root) {
    if (root.__gbb) return;
    root.__gbb = true;

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-gbb-config]').textContent); } catch (e) {}
    var store = storage();
    var sel = [];
    var open = false;
    var busy = false;

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var panel = $('[data-gbb-panel]');
    var cards = $$('[data-gbb-card]');
    // Arriving from a product page ("Make it a panty pack" link adds ?from=<product id>): that piece goes first
    try {
      var fromId = new URLSearchParams(window.location.search).get('from');
      if (fromId) cards.forEach(function (c) { c.classList.toggle('is-from', c.getAttribute('data-product-id') === fromId); });
    } catch (e) {}
    var money = function (c) { return formatMoney(c, cfg.moneyFormat); };
    // editable wording from the section settings ({n} {pct} {saving} {pieces})
    var T = cfg.text || {};
    function txt(key, fallback, vars) {
      var s = (T[key] != null && T[key] !== '') ? String(T[key]) : fallback;
      vars = vars || {};
      return s.replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : m; });
    }

    // restore (only variants still on the page)
    if (store && cfg.storageKey) {
      try {
        var saved = JSON.parse(store.getItem(cfg.storageKey) || '[]');
        var seen = {};
        sel = saved.filter(function (s) { if (seen[s.variantId]) return false; seen[s.variantId] = 1; return root.querySelector('[data-gbb-add][data-variant-id="' + s.variantId + '"]:not([disabled])'); }).slice(0, MAX);
      } catch (e) { sel = []; }
    }
    function persist() { if (store && cfg.storageKey) { try { store.setItem(cfg.storageKey, JSON.stringify(sel)); } catch (e) {} } }

    function status(text, isError) {
      var el = $('[data-gbb-status]');
      if (!text) { el.hidden = true; el.textContent = ''; return; }
      el.hidden = false; el.textContent = text;
      el.classList.toggle('is-error', !!isError);
    }

    function render() {
      var s = summarise(sel);

      // counts + progress
      $('[data-gbb-count]').textContent = s.n + ' of ' + MAX;
      $('[data-gbb-fill]').style.width = Math.min(100, s.n / MAX * 100) + '%';
      $$('[data-gbb-mk]').forEach(function (mk) { mk.classList.toggle('is-on', s.n >= Number(mk.getAttribute('data-gbb-mk'))); });

      var msg = $('[data-gbb-msg]');
      var left = 3 - s.n;
      if (s.n === 0) msg.textContent = txt('msgEmpty', s.msg);
      else if (s.n < 3) msg.textContent = txt('msgShort', s.msg, { n: left, pieces: left === 1 ? 'piece' : 'pieces' });
      else if (!s.full) msg.textContent = txt('msgOn', s.msg + ' — you’re saving {saving}', { pct: s.pct, saving: money(s.save) });
      else msg.textContent = txt('msgFull', s.msg, { pct: s.pct, saving: money(s.save) });
      if (s.upsell) s.upsell = txt('upsell', s.upsell, { pct: pctFor(s.n + 1) });
      msg.classList.toggle('is-ok', s.ok);
      var up = $('[data-gbb-upsell]');
      up.hidden = !s.upsell;
      $('[data-gbb-upsell-label]').textContent = s.upsell;

      // slots
      var html = '';
      for (var i = 0; i < MAX; i++) {
        var it = sel[i];
        if (it) {
          html += '<li class="gbb-slot">' +
            (it.image ? '<img src="' + esc(it.image) + '" alt="" width="52" height="68" loading="lazy">' : '<span class="gbb-slot__box"></span>') +
            '<div><p class="gbb-slot__name">' + esc(it.title) + '</p><p class="gbb-slot__meta">' + esc(it.vendor) + ' · ' + esc(it.size) + '</p></div>' +
            '<span class="gbb-slot__price">' + esc(money(it.price)) + '</span>' +
            '<button type="button" class="gbb-slot__remove" data-gbb-remove="' + i + '" aria-label="Remove ' + esc(it.title + ', ' + it.size) + '">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></li>';
        } else {
          var hint = i < 2 ? 'Choose a piece' : 'Unlocks ' + pctFor(i + 1) + '% off';
          html += '<li class="gbb-slot gbb-slot--empty"><span class="gbb-slot__box">' + (i + 1) + '</span><span>' + hint + '</span></li>';
        }
      }
      $('[data-gbb-slots]').innerHTML = html;

      // compact thumbs (mobile)
      var th = '';
      for (var j = 0; j < MAX; j++) {
        var t = sel[j];
        th += t && t.image ? '<img class="gbb-thumb" src="' + esc(t.image) + '" alt="' + esc(t.title) + '" width="44" height="58">' : '<span class="gbb-thumb--empty">' + (j + 1) + '</span>';
      }
      $('[data-gbb-thumbs]').innerHTML = th;

      // totals
      $('[data-gbb-sub-row]').hidden = !s.ok;
      $('[data-gbb-save-row]').hidden = !s.ok;
      $('[data-gbb-sub]').textContent = money(s.sub);
      $('[data-gbb-save]').textContent = '−' + money(s.save);
      $('[data-gbb-total]').textContent = money(s.total);
      $('[data-gbb-total-compact]').textContent = s.n ? money(s.total) : '';

      // CTA
      var cta = $('[data-gbb-submit]');
      if (!busy) {
        cta.disabled = s.n < 3;
        cta.textContent = s.n >= 3 ? txt('cta', 'Add to cart') : txt('ctaPending', 'Choose {n} more {pieces}', { n: 3 - s.n, pieces: (3 - s.n) === 1 ? 'piece' : 'pieces' });
      }

      // cards: badges + full state
      var counts = {}, picks = {};
      sel.forEach(function (x) { picks[x.variantId] = true; });
      sel.forEach(function (x) { counts[x.productId] = (counts[x.productId] || 0) + 1; });
      cards.forEach(function (card) {
        var c = counts[card.getAttribute('data-product-id')] || 0;
        var b = card.querySelector('[data-gbb-badge]');
        b.hidden = !c;
        b.textContent = c > 1 ? 'In bundle ×' + c : 'In bundle';
        card.querySelectorAll('[data-gbb-add]').forEach(function (btn) {
          if (btn.hasAttribute('data-soldout')) return;
          var picked = !!picks[btn.getAttribute('data-variant-id')];
          btn.classList.toggle('is-picked', picked);
          btn.setAttribute('aria-pressed', picked ? 'true' : 'false');
          btn.disabled = s.full && !picked; // a picked piece can always be tapped to remove it
          if (btn.classList.contains('gbb-add')) {
            if (!btn.__label) btn.__label = btn.innerHTML;
            btn.innerHTML = picked ? 'Added ✓' : (s.full ? 'Full' : btn.__label);
          }
        });
        // "Add to bundle" bar that opens into sizes
        var bar = card.querySelector('[data-gbb-reveal]');
        if (bar) {
          var pid = card.getAttribute('data-product-id');
          var sizes = sel.filter(function (x) { return x.productId === pid; }).map(function (x) { return x.size; });
          var has = sizes.length > 0;
          bar.classList.toggle('is-picked', has);
          bar.disabled = s.full && !has;
          bar.querySelector('[data-gbb-bar-long]').textContent = has ? 'Added · ' + sizes.join(', ') : (s.full ? 'Bundle full' : 'Add to bundle');
          bar.querySelector('[data-gbb-bar-short]').textContent = has ? '✓ ' + sizes.join(', ') : (s.full ? 'Full' : 'Add');
        }
      });

      // panel state
      panel.classList.toggle('is-empty', s.n === 0);
      if (s.n === 0) open = false;
      panel.classList.toggle('is-open', open);
      var tg = $('[data-gbb-toggle]');
      tg.setAttribute('aria-expanded', open ? 'true' : 'false');
      $('[data-gbb-toggle-label]').textContent = open ? 'Hide' : 'Review';
    }

    /* ---------- quick view ---------- */
    var qv = $('[data-gbb-qv-dialog]');
    var qvCard = null, qvTrigger = null;

    function qvData(card) {
      try { return JSON.parse(card.querySelector('[data-gbb-qv-data]').textContent); }
      catch (e) { return { images: [], description: '', url: '' }; }
    }

    function qvShow(i) {
      var track = qv.querySelector('[data-gbb-qv-track]');
      var slide = track.children[i];
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      qvMark(i);
    }

    function qvMark(i) {
      qv.querySelectorAll('[data-gbb-qv-thumb], [data-gbb-qv-dot]').forEach(function (b) {
        var j = Number(b.getAttribute('data-gbb-qv-thumb') || b.getAttribute('data-gbb-qv-dot'));
        b.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
    }

    /* mobile: dots over the photo show there are more images to swipe */
    function qvDots(n) {
      var box = qv.querySelector('[data-gbb-qv-dots]');
      if (!box) {
        box = document.createElement('div');
        box.className = 'gbb-qv__dots'; box.setAttribute('data-gbb-qv-dots', '');
        qv.querySelector('[data-gbb-qv-track]').insertAdjacentElement('afterend', box);
      }
      var h = '';
      for (var k = 0; k < n; k++) h += '<button type="button" class="gbb-qv__dot" data-gbb-qv-dot="' + k + '" aria-label="Image ' + (k + 1) + ' of ' + n + '" aria-current="' + (k === 0 ? 'true' : 'false') + '"></button>';
      box.innerHTML = n > 1 ? h : '';
    }

    function openQuickView(card, trigger) {
      if (!qv || typeof qv.showModal !== 'function') return false;
      qvCard = card; qvTrigger = trigger;
      var d = qvData(card);
      var s = summarise(sel);
      var title = card.getAttribute('data-vendor') + ' ' + card.getAttribute('data-title');

      qv.querySelector('[data-gbb-qv-vendor]').textContent = card.getAttribute('data-vendor');
      qv.querySelector('[data-gbb-qv-title]').textContent = card.getAttribute('data-title');
      qv.querySelector('[data-gbb-qv-price]').textContent = card.querySelector('.gbb-card__price').textContent;
      renderDescription(d.description || '', qv.querySelector('[data-gbb-qv-desc]'), 'gbb-qv__desc');
      var link = qv.querySelector('[data-gbb-qv-link]');
      link.href = d.url || '#'; link.hidden = !d.url;

      var imgs = d.images || [];
      qv.querySelector('[data-gbb-qv-track]').innerHTML = imgs.map(function (im, i) {
        return '<img src="' + esc(im.src) + '" alt="' + esc(im.alt || title) + '" loading="' + (i ? 'lazy' : 'eager') + '">';
      }).join('');
      qvDots(imgs.length);
      qv.querySelector('[data-gbb-qv-thumbs]').innerHTML = imgs.length > 1 ? imgs.map(function (im, i) {
        return '<button type="button" class="gbb-qv__thumb" data-gbb-qv-thumb="' + i + '" aria-label="Image ' + (i + 1) + ' of ' + imgs.length + '" aria-current="' + (i === 0 ? 'true' : 'false') + '"><img src="' + esc(im.thumb) + '" alt=""></button>';
      }).join('') : '';
      qv.querySelector('[data-gbb-qv-track]').scrollLeft = 0;

      // copy the card's size / add buttons so they behave exactly the same
      var controls = card.querySelector('.gbb-sizes') || card.querySelector('.gbb-add');
      var box = qv.querySelector('[data-gbb-qv-controls]');
      box.innerHTML = '';
      if (controls) box.appendChild(controls.cloneNode(true));


      qv.showModal();
      document.documentElement.classList.add('gbb-qv-open');
      return true;
    }

    function closeQuickView() {
      if (qv && qv.open) qv.close();
    }

    if (qv) {
      qv.addEventListener('close', function () {
        document.documentElement.classList.remove('gbb-qv-open');
        if (qvTrigger) { try { qvTrigger.focus({ preventScroll: true }); } catch (e) {} }
        qvCard = null; qvTrigger = null;
      });
      qv.addEventListener('click', function (e) { if (e.target === qv) closeQuickView(); }); // backdrop
      qv.querySelector('[data-gbb-qv-track]').addEventListener('scroll', function () {
        var tr = this, i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
        qvMark(i);
      }, { passive: true });
    }

    function add(btn) {
      var vid = btn.getAttribute('data-variant-id');
      var existing = -1;
      sel.forEach(function (x, i) { if (x.variantId === vid) existing = i; });
      if (existing > -1) { // same SKU only once: tapping it again removes it
        sel.splice(existing, 1); status(''); persist(); render();
        if (!btn.closest('[data-gbb-card]')) closeQuickView(); else closePick(btn.closest('[data-gbb-pickwrap]'));
        return;
      }
      if (sel.length >= MAX || btn.disabled) return;
      var card = btn.closest('[data-gbb-card]') || qvCard;
      if (!card) return;
      var fromQv = !btn.closest('[data-gbb-card]');
      sel.push({
        variantId: btn.getAttribute('data-variant-id'),
        productId: card.getAttribute('data-product-id'),
        title: card.getAttribute('data-title'),
        vendor: card.getAttribute('data-vendor'),
        image: card.getAttribute('data-image'),
        size: btn.getAttribute('data-size'),
        price: Number(btn.getAttribute('data-price')) || 0
      });
      status('');
      persist(); render();
      if (fromQv) closeQuickView(); else closePick(btn.closest('[data-gbb-pickwrap]'));
    }

    /* ---------- "Add to bundle" bar -> sizes ---------- */
    function closePick(w) {
      if (!w || !w.classList.contains('is-open')) return;
      w.classList.remove('is-open');
      var b = w.querySelector('[data-gbb-reveal]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    function closeAllPicks(except) {
      $$('[data-gbb-pickwrap].is-open').forEach(function (w) { if (w !== except) closePick(w); });
    }
    function openPick(w) {
      closeAllPicks(w);
      w.classList.add('is-open');
      w.querySelector('[data-gbb-reveal]').setAttribute('aria-expanded', 'true');
      var first = w.querySelector('.gbb-size:not(:disabled)');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-gbb-pickwrap]')) closeAllPicks(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var w = root.querySelector('[data-gbb-pickwrap].is-open');
      if (w) { closePick(w); var b = w.querySelector('[data-gbb-reveal]'); if (b) b.focus(); }
    });

    function remove(i) {
      sel.splice(i, 1);
      persist(); render();
    }

    function filter(tag) {
      $$('[data-gbb-filter]').forEach(function (chip) {
        var on = chip.getAttribute('data-gbb-filter') === tag;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var shown = 0;
      cards.forEach(function (card) {
        var match = !tag || card.getAttribute('data-tags').indexOf('|' + tag + '|') > -1;
        card.hidden = !match;
        if (match) shown++;
      });
      var el = $('[data-gbb-shown]');
      if (el) el.textContent = shown + (shown === 1 ? ' piece' : ' pieces');
    }

    function submit() {
      if (busy || sel.length < 3) return;
      busy = true;
      var cta = $('[data-gbb-submit]');
      cta.disabled = true; cta.classList.add('is-loading'); cta.textContent = 'Adding…';
      status('');

      var items = groupItems(sel, newBundleId(), cfg.bundleLabel || 'Build your bundle');
      fetch(cfg.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Something went wrong. Please try again.');
          sel = []; persist();
          busy = false; cta.classList.remove('is-loading');
          render();
          status(txt('added', 'Added to your cart.'));
          if (cfg.afterAdd === 'cart') { window.location.href = cfg.cartUrl || '/cart'; return; }
          openCartDrawer(cfg, items);
        })
        .catch(function (err) {
          busy = false; cta.classList.remove('is-loading');
          render();
          status(err.message, true);
        });
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var rv = t.closest('[data-gbb-reveal]'); if (rv) { if (!rv.disabled) openPick(rv.closest('[data-gbb-pickwrap]')); return; }
      var a = t.closest('[data-gbb-add]'); if (a) { add(a); return; }
      var q = t.closest('[data-gbb-qv]'); if (q) { openQuickView(q.closest('[data-gbb-card]'), q); return; }
      if (t.closest('[data-gbb-qv-close]')) { closeQuickView(); return; }
      var th = t.closest('[data-gbb-qv-thumb], [data-gbb-qv-dot]'); if (th) { qvShow(Number(th.getAttribute('data-gbb-qv-thumb') || th.getAttribute('data-gbb-qv-dot'))); return; }
      var r = t.closest('[data-gbb-remove]'); if (r) { remove(Number(r.getAttribute('data-gbb-remove'))); return; }
      var f = t.closest('[data-gbb-filter]'); if (f) { filter(f.getAttribute('data-gbb-filter')); return; }
      if (t.closest('[data-gbb-toggle]')) { open = !open; render(); return; }
      if (t.closest('[data-gbb-submit]')) { submit(); return; }
      if (t.closest('[data-gbb-upsell]')) { open = false; render(); }
    });

    /* keep the panel clear of the theme's sticky / fixed header.
       Themes often switch the header to fixed only after you start scrolling, so instead of
       looking for it once, we check what is actually covering the top of the screen above the
       panel on every scroll. */
    var ticking = false;
    function coveringBottom(x, y) {
      var els = document.elementsFromPoint ? document.elementsFromPoint(x, y) : [];
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (root.contains(el)) continue;
        for (var n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
          var pos = getComputedStyle(n).position;
          if (pos === 'fixed' || pos === 'sticky') {
            var r = n.getBoundingClientRect();
            if (r.top <= y && r.bottom > y && r.height < window.innerHeight / 2) return r.bottom;
          }
        }
      }
      return 0;
    }
    function updateStickyTop() {
      ticking = false;
      var pr = panel.getBoundingClientRect();
      var x = Math.min(window.innerWidth - 2, Math.max(1, pr.left + pr.width / 2));
      var bottom = 0, y = 1;
      for (var k = 0; k < 4; k++) { // stacked bars: announcement + header etc.
        var b = coveringBottom(x, y);
        if (b <= bottom) break;
        bottom = b; y = b + 1;
      }
      root.style.setProperty('--gbb-sticky-top', Math.round(bottom + 16) + 'px');
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(updateStickyTop); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateStickyTop();

    /* ---------- line the page up with the theme's logo (desktop) ---------- */
    function findLogo() {
      var hdr = document.querySelector('header, .header, [id*="header"], [class*="header"]');
      if (!hdr) return null;
      var tries = ['[class*="logo"] img', '[class*="logo"] svg', 'a[href="/"] img', 'a[href="/"] svg', 'a[href="/"]', '[class*="logo"]'];
      for (var i = 0; i < tries.length; i++) {
        var list = hdr.querySelectorAll(tries[i]);
        for (var j = 0; j < list.length; j++) { if (list[j].getBoundingClientRect().width > 20) return list[j]; }
      }
      return null;
    }
    function alignToLogo() {
      var logo = findLogo();
      if (!logo || window.innerWidth < 990) { root.classList.remove('is-aligned'); return; }
      var lr = logo.getBoundingClientRect(), rr = root.getBoundingClientRect();
      var gutter = Math.round(lr.left - rr.left);
      if (!lr.width || gutter < 16 || lr.left > window.innerWidth * 0.3) { root.classList.remove('is-aligned'); return; }
      root.style.setProperty('--gbb-gutter', gutter + 'px');
      root.classList.add('is-aligned');
    }
    var alignT;
    window.addEventListener('resize', function () { clearTimeout(alignT); alignT = setTimeout(alignToLogo, 120); });
    alignToLogo(); window.addEventListener('load', alignToLogo);
    setTimeout(updateStickyTop, 600); // after the theme's header script has run

    filter('');
    render();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-gbb]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot); // theme editor
})();

/* ---------- card photo swipe + dots (touch screens) ---------- */
(function () {
  var P = 'gbb', CARD = '[data-gbb-card]', DATA = '[data-gbb-qv-data]', ROOT = '[data-gbb]';
  var mq = window.matchMedia ? window.matchMedia('(hover: none)') : null;
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function path(u) { try { return new URL(u, location.href).pathname; } catch (e) { return String(u).split('?')[0]; } }
  function sized(u, w) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function build(card) {
    if (card.__gbSwipe) return; card.__gbSwipe = true;
    var media = card.querySelector('.' + P + '-card__media');
    var trig = media && media.querySelector('[data-' + P + '-qv]');
    var json = card.querySelector(DATA);
    if (!media || !trig) return;
    var dots = document.createElement('div');
    dots.className = 'gb-swipe__dots'; dots.setAttribute('aria-hidden', 'true');
    media.insertAdjacentElement('afterend', dots); // empty row keeps cards lined up
    var d = {}; try { d = JSON.parse(json.textContent); } catch (e) {}
    var first = trig.querySelector('.' + P + '-card__img:not(.' + P + '-card__img--hover)');
    var firstSrc = first ? (first.currentSrc || first.src) : '';
    var seen = {}; if (firstSrc) seen[path(firstSrc)] = 1;
    var extra = (d.images || []).filter(function (im) { var p = path(im.src); if (!im.src || seen[p]) return false; seen[p] = 1; return true; }).slice(0, 5);
    if (!extra.length) return;
    var slides = (firstSrc ? [firstSrc] : []).concat(extra.map(function (im) { return sized(im.src, 600); }));
    var track = document.createElement('div');
    track.className = 'gb-swipe';
    track.setAttribute('data-' + P + '-qv', ''); // a tap still opens quick view
    track.setAttribute('aria-hidden', 'true');
    track.innerHTML = slides.map(function (src, k) { return '<img src="' + esc(src) + '" alt="" draggable="false"' + (k ? ' loading="lazy"' : '') + '>'; }).join('');
    trig.insertAdjacentElement('afterend', track);
    dots.innerHTML = slides.map(function (s, k) { return '<span' + (k ? '' : ' class="is-on"') + '></span>'; }).join('');
    card.classList.add('has-swipe');
    var cur = 0;
    track.addEventListener('scroll', function () {
      var k = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (k === cur) return; cur = k;
      Array.prototype.forEach.call(dots.children, function (s, j) { s.classList.toggle('is-on', j === k); });
    }, { passive: true });
    track.addEventListener('click', function () {
      if (!cur) return;
      var k = cur, scope = card.closest(ROOT) || document;
      setTimeout(function () { // open quick view on the photo they were looking at
        var qt = scope.querySelector('[data-' + P + '-qv-track]') || document.querySelector('[data-' + P + '-qv-track]');
        var img = qt && qt.children[k];
        if (img) { qt.scrollLeft = img.offsetLeft; qt.dispatchEvent(new Event('scroll')); }
      }, 30);
    });
  }
  function run() {
    if (mq && !mq.matches) return;
    Array.prototype.forEach.call(document.querySelectorAll(CARD), build);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  if (mq && mq.addEventListener) mq.addEventListener('change', run);
})();